import React from 'react';

export interface ChartCardProps {
  /** Card title (h3) */
  title?: string;
  /** Subtitle / period text (p) */
  subtitle?: string;
  /** Custom header content (e.g. toggles, badges). When set, title/subtitle are ignored for the header. */
  headerContent?: React.ReactNode;
  /** Extra class for the header div, e.g. "chart-header-net-worth" */
  headerClassName?: string;
  /** Use large card variant */
  large?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

/**
 * Wrapper for Recharts (or other chart) content: .chart-card + optional .chart-header + .chart-container.
 * Uses existing CSS classes so visuals stay the same.
 */
const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  headerContent,
  headerClassName = '',
  large = false,
  style,
  children,
}) => {
  const cardClassName = `chart-card${large ? ' large' : ''}`;
  const headerClass = headerClassName ? `chart-header ${headerClassName}`.trim() : 'chart-header';

  return (
    <div className={cardClassName} style={style}>
      {(headerContent ?? title ?? subtitle) && (
        <div className={headerClass}>
          {headerContent ?? (
            <>
              {title && <h3>{title}</h3>}
              {subtitle && <p>{subtitle}</p>}
            </>
          )}
        </div>
      )}
      <div className="chart-container">{children}</div>
    </div>
  );
};

export default ChartCard;
